import { render, staticRenderFns } from "./SuperadminDataTable.vue?vue&type=template&id=23a9f0fb&scoped=true"
import script from "./SuperadminDataTable.vue?vue&type=script&lang=js"
export * from "./SuperadminDataTable.vue?vue&type=script&lang=js"
import style0 from "./SuperadminDataTable.vue?vue&type=style&index=0&id=23a9f0fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9f0fb",
  null
  
)

export default component.exports